const parseDateValue = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const resolveEventStartDate = (newEvent = {}, editingEvent = {}) =>
  parseDateValue(newEvent?.startDate) ||
  parseDateValue(editingEvent?.startDate) ||
  parseDateValue(newEvent?.plannedStartDate) ||
  parseDateValue(editingEvent?.plannedStartDate) ||
  null;

const resolveActualEventEndDate = (newEvent = {}, editingEvent = {}) =>
  parseDateValue(newEvent?.endDate) || parseDateValue(editingEvent?.endDate) || null;

export const computeDefaultDelayStartDate = (newEvent, editingEvent, now = new Date()) => {
  const eventEnd = resolveActualEventEndDate(newEvent, editingEvent);
  const eventStart = resolveEventStartDate(newEvent, editingEvent);
  if (!eventEnd || eventEnd >= now) {
    return now;
  }
  return eventStart || now;
};

export const validateDelayDateRange = (
  delayStartValue,
  delayEndValue,
  newEvent,
  editingEvent,
  now = new Date()
) => {
  const delayStart = parseDateValue(delayStartValue);
  const delayEnd = parseDateValue(delayEndValue);
  const eventStart = resolveEventStartDate(newEvent, editingEvent);
  const eventEnd = resolveActualEventEndDate(newEvent, editingEvent);
  const errors = {};

  if (delayStart && eventStart && delayStart < eventStart) {
    errors.delayStartDate = 'Delay start must be on or after the event start date/time.';
  }

  const startUpperBound = eventEnd || now;
  if (!errors.delayStartDate && delayStart && startUpperBound && delayStart >= startUpperBound) {
    errors.delayStartDate = eventEnd
      ? 'Delay start must be before the event end date/time.'
      : 'Delay start must be before the current date/time.';
  }

  if (delayStart && delayEnd && delayEnd <= delayStart) {
    errors.delayEndDate = 'Delay end must be after the delay start date/time.';
  }

  const endUpperBound = eventEnd || now;
  if (!errors.delayEndDate && delayEnd && endUpperBound && delayEnd > endUpperBound) {
    errors.delayEndDate = eventEnd
      ? 'Delay end must be on or before the event end date/time.'
      : 'Delay end must be on or before the current date/time.';
  }

  return errors;
};
